module.exports = __webpack_public_path__ + "static/media/Badges.a1438e7a.svg";